/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type FetchDatabricksAccessTokenForSuccessViewMutationVariables =
  Types.Exact<{
    code: Types.Scalars["String"]["input"];
    state: Types.Scalars["String"]["input"];
  }>;

export type FetchDatabricksAccessTokenForSuccessViewMutation = {
  readonly __typename: "Mutation";
  readonly fetchDatabricksAccessToken: {
    readonly __typename: "DatabricksOAuthConnection";
    readonly id: c.DatabricksOAuthConnectionId;
    readonly accessTokenExpires: c.DateTimeString | null;
    readonly linkedDataConnections: ReadonlyArray<{
      readonly __typename: "DataConnection";
      readonly id: c.DataConnectionId;
    }>;
  };
};

export const FetchDatabricksAccessTokenForSuccessViewDocument = /*#__PURE__*/ gql`
  mutation FetchDatabricksAccessTokenForSuccessView(
    $code: String!
    $state: String!
  ) {
    fetchDatabricksAccessToken(code: $code, state: $state) {
      id
      accessTokenExpires
      linkedDataConnections {
        id
      }
    }
  }
`;
export type FetchDatabricksAccessTokenForSuccessViewMutationFn =
  Apollo.MutationFunction<
    FetchDatabricksAccessTokenForSuccessViewMutation,
    FetchDatabricksAccessTokenForSuccessViewMutationVariables
  >;

/**
 * __useFetchDatabricksAccessTokenForSuccessViewMutation__
 *
 * To run a mutation, you first call `useFetchDatabricksAccessTokenForSuccessViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchDatabricksAccessTokenForSuccessViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchDatabricksAccessTokenForSuccessViewMutation, { data, loading, error }] = useFetchDatabricksAccessTokenForSuccessViewMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useFetchDatabricksAccessTokenForSuccessViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FetchDatabricksAccessTokenForSuccessViewMutation,
    FetchDatabricksAccessTokenForSuccessViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FetchDatabricksAccessTokenForSuccessViewMutation,
    FetchDatabricksAccessTokenForSuccessViewMutationVariables
  >(FetchDatabricksAccessTokenForSuccessViewDocument, options);
}
export type FetchDatabricksAccessTokenForSuccessViewMutationHookResult =
  ReturnType<typeof useFetchDatabricksAccessTokenForSuccessViewMutation>;
export type FetchDatabricksAccessTokenForSuccessViewMutationResult =
  Apollo.MutationResult<FetchDatabricksAccessTokenForSuccessViewMutation>;
export type FetchDatabricksAccessTokenForSuccessViewMutationOptions =
  Apollo.BaseMutationOptions<
    FetchDatabricksAccessTokenForSuccessViewMutation,
    FetchDatabricksAccessTokenForSuccessViewMutationVariables
  >;
